import { useContext } from 'react'
import { appStateContext } from 'src/contexts/AppState'

const useAppState = () => useContext(appStateContext)

export default useAppState
